/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbFacilityPage } from './HchbFacilityPage';
import {
    HchbFacilityPageFromJSON,
    HchbFacilityPageFromJSONTyped,
    HchbFacilityPageToJSON,
    HchbFacilityPageToJSONTyped,
} from './HchbFacilityPage';

/**
 * 
 * @export
 * @interface FindAllHchbFacilities200Response
 */
export interface FindAllHchbFacilities200Response {
    /**
     * 
     * @type {HchbFacilityPage}
     * @memberof FindAllHchbFacilities200Response
     */
    data?: HchbFacilityPage;
}

/**
 * Check if a given object implements the FindAllHchbFacilities200Response interface.
 */
export function instanceOfFindAllHchbFacilities200Response(value: object): value is FindAllHchbFacilities200Response {
    return true;
}

export function FindAllHchbFacilities200ResponseFromJSON(json: any): FindAllHchbFacilities200Response {
    return FindAllHchbFacilities200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbFacilities200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbFacilities200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbFacilityPageFromJSON(json['data']),
    };
}

export function FindAllHchbFacilities200ResponseToJSON(json: any): FindAllHchbFacilities200Response {
    return FindAllHchbFacilities200ResponseToJSONTyped(json, false);
}

export function FindAllHchbFacilities200ResponseToJSONTyped(value?: FindAllHchbFacilities200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbFacilityPageToJSON(value['data']),
    };
}

